import { For, Show } from 'solid-js';
import { state, dismissToast } from '../state';

const ICONS = { info: 'i', success: '✓', warn: '!', danger: '×' };

export function Toasts() {
  return (
    <ul class="toasts" aria-live="polite">
      <For each={state.toasts}>
        {(t) => (
          <li class={`toast ${t.severity}`}>
            <span class="toast-icon">{ICONS[t.severity]}</span>
            <div>
              <div class="toast-title">{t.title}</div>
              <Show when={t.body}><div class="toast-body">{t.body}</div></Show>
              <Show when={t.actions && t.actions.length > 0}>
                <div class="toast-action">
                  <For each={t.actions}>
                    {(a) => <button onClick={() => { a.run(); dismissToast(t.id); }}>{a.label}</button>}
                  </For>
                </div>
              </Show>
            </div>
            <button class="toast-close" aria-label="Close" onClick={() => dismissToast(t.id)}>×</button>
          </li>
        )}
      </For>
    </ul>
  );
}
